<style>
  div.tabs {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }

  @media screen and (width < 1200px) {
    div.tabs {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
  }
</style>

<div id="billingInformationContainer">
  <div style="width: 100%">
    <div style="display: flex; align-items: start; gap: 10px; justify-content: space-between;">
      <div>
        <h2 class="cpo-section-title">Processing</h2>
      </div>
      @if (this.enableEditing) {
        <div [hidden]="this.mode != FormMode.View">
          <span class="cpo-edit-link" (click)="btnEdit_click()">Edit</span>
        </div>
      }
    </div>
  </div>

  @if (!onboarding && this.mode == FormMode.View) {
    @if (processors.length > 0) {
      <div style="display: flex; align-items: stretch; justify-content: space-between; flex-wrap: wrap; flex-direction: column; padding: 0px 30px 0px 30px;">
        @for (p of processors; track p) {
          <div style="display: flex; flex-direction: row; justify-content: space-between; flex: 1; padding: 0px 0px 10px">
            <div class="cpo-pod">
              <span class="title">Processor</span>
              <span class="r1">{{ p.processor }}</span>
            </div>
            <div class="cpo-pod">
              <span class="title">Processor Type</span>
              <span class="r1">{{ p.processorType }}</span>
            </div>
            @if (p.processorType != 'Card') {
              <div class="cpo-pod">
                <span class="title">Paya MID</span>
                <span class="r1">{{ p.mid }}</span>
              </div>
            } @else {
              <div class="cpo-pod">
                <span class="title">MID</span>
                <span class="r1">{{ p.mid }}</span>
              </div>
            }
            <div class="cpo-pod">
              <span class="title">Gateway</span>
              <span class="r1">{{ p.gateway }}</span>
            </div>
            <div class="cpo-pod">
              <span class="title">Status</span>
              <span class="r1">{{ p.status }}</span>
            </div>
          </div>
        }
      </div>
    }
  }

  @if (onboarding || this.mode == FormMode.Edit) {
    <div class="flex-container cpo-section-form">
      <div style="flex: 10">  
        <div
          style="display: flex; align-items: start; gap: 40px; margin-bottom: 20px;"
        >
          <div style="flex: 1">
            <div>
              <app-selectbox
                [label]="'Gateway'"
                [type]="ddlModes.Gateways"
                [required]="true"
                [(ngModel)]="this.onboardingProcessor.gateway"
                [readonly]="this.mode == FormMode.View"
                [options]="gateway"
              ></app-selectbox>
            </div>
          </div>
          <div style="flex: 1">
            <div>
              <app-selectbox
                [label]="'Processor'"
                [type]="ddlModes.CCProcessors"
                [required]="true"
                [(ngModel)]="this.onboardingProcessor.processor"
                (onChanged)="btnChangeType_click($event)"
                [multiple]="true"
                [readonly]="this.mode == FormMode.View"
                [options]="processor"
              ></app-selectbox>
            </div>
          </div>
        </div>
    
        <div
          style="
            display: flex;
            align-items: start;
            gap: 40px;
            padding: 20px;
            margin-bottom: 20px;
            margin-top: 40px;
          "
          *ngIf="onboardingProcessor.processorType?.includes('Card')"
        >
          <div style="flex: 1">
            <div>
              <app-textbox
                [label]="'FiservMID'"
                [required]="true"
                [(ngModel)]="onboardingProcessor.mid"
                [readonly]="mode == FormMode.View"
              ></app-textbox>
            </div>
          </div>
          <div style="flex: 1">
            <div>
              <app-textbox
                [label]="'Terminal ID'"
                [helpText]="'7 digit numeric code'"
                [required]="true"
                [(ngModel)]="onboardingProcessor.cardTerminalId"
                [type]="inputModes.FiservTerminalId"
                [readonly]="mode == FormMode.View"
              ></app-textbox>
            </div>
          </div>
        </div>
    
        <div
          style="
            display: flex;
            align-items: start;
            gap: 40px;
            padding: 20px;
            margin-bottom: 10px;
            margin-top: 40px;
          "
          *ngIf="onboardingProcessor.processorType?.includes('ACH')"
        >
          <div style="flex: 1;">
            <div>
              <app-textbox
                [label]="'Paya MID'"
                [required]="true"
                [(ngModel)]="onboardingProcessor.achMid"
                [readonly]="mode == FormMode.View"
              ></app-textbox>
            </div>
            <div>
              <app-textbox
                [label]="'WEB Terminal ID'"
                [required]="true"
                [(ngModel)]="onboardingProcessor.webTerminalId"
                [readonly]="mode == FormMode.View"
              ></app-textbox>
            </div>
          </div>
          <div style="flex: 1">
            <div>
              <app-textbox
                [label]="'PPD Terminal ID'"
                [required]="true"
                [(ngModel)]="onboardingProcessor.ppdTerminalId"
                [readonly]="mode == FormMode.View"
              ></app-textbox>
            </div>
            <div>
              <app-textbox
                [label]="'CCD Terminal ID'"
                [required]="true"
                [(ngModel)]="onboardingProcessor.ccdTerminalId"
                [readonly]="mode == FormMode.View"
              ></app-textbox>
            </div>
          </div>
        </div>
        @if (this.enableEditing) {
          <div style="display: flex; gap: 20px; justify-content: center; padding: 20px 0px 0px 0px;">
            <button class="btn-secondary" style="width: 150px;" (click)="this.btnCancelClick()"> Cancel </button>
            <button class="btn-primary" style="width: 150px;" (click)="this.btnSaveClick()"> Save </button>
          </div>
        }
      </div>
    </div>
  }
</div>

